import { CREATE_JOURNEY_FAILED, CREATE_JOURNEY_REQUEST, CREATE_JOURNEY_STEP, CREATE_JOURNEY_STEP_FAILED, CREATE_JOURNEY_STEP_SUCCEDDED, CREATE_JOURNEY_SUCCEDDED, CREATE_JOURNEY_SUCCESS, DELETE_JOURNEY_REQUEST, DELETE_JOURNEY_STEP, DELETING_JOURNEY_FAILED, DELETING_JOURNEY_STEP_FAILED, DELETING_JOURNEY_STEP_SUCCEDDED, DELETING_JOURNEY_SUCCEDDED, FETCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST, FETCH_JOURNEY_REQUEST, FETCH_JOURNEYS_REQUEST, FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_FAILED, FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_SUCCEEDED, FETCHING_JOURNEY_FAILED, FETCHING_JOURNEY_SUCCEDDED, FETCHING_JOURNEY_SUCCESS, FETCHING_JOURNEYS_FAILED, FETCHING_JOURNEYS_SUCCEDDED, FETCHING_JOURNEYS_SUCCESS, FETRCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST, INVALIDATE_JOURNEY_CONTENT_MANAGER_MAPPINGS, UPDATE_JOURNEY_DATA_REQUEST, UPDATE_JOURNEY_DYNAMIC_CONTENT_MANAGER, UPDATE_JOURNEY_REQUEST, UPDATE_JOURNEY_STEP, UPDATING_JOURNEY_FAILED, UPDATING_JOURNEY_STEP_FAILED, UPDATING_JOURNEY_STEP_SUCCEDDED, UPDATING_JOURNEY_SUCCEDDED, UPDATING_JOURNEY_SUCCESS } from 'constants/actionTypes';

import { put, call, takeEvery, select, take, race, fork, delay } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import moment from 'moment';
import axios from 'axios';
import buildUrl from 'build-url';
import _ from 'lodash';
import { createMixpanelEvent } from "actions/mixpanel";
import { JOURNEY_CREATED } from "constants/mixpanelEvents";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const JOURNEY_URL = `${apiUrl}/api/2.0/journey`;
const CONTENT_MAPPING_URL = `${apiUrl}/api/2.0/content-mappings`
/**
 * Create journey
*/
export const createJourney = createAction(CREATE_JOURNEY_REQUEST, (request) => {

  return {
    request: request,
  };
})

export const createJourneySucceeded = createAction(CREATE_JOURNEY_SUCCEDDED, (response) => {
  return response;
})

export const createJourneyFailed = createAction(CREATE_JOURNEY_FAILED, (error) => {
  return error;
})

function* createJourneySaga(action) {
  const storyboard = yield select(state => _.get(state, "storyboards.storyboard.item", null));
  const { request } = action.payload;
  const createJourneyAPI = () => {
    return axios.post(JOURNEY_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createJourneyAPI);
    if (response) {
        var mixpanelPayload = {
          storyboard_id: storyboard.id,
          storyboard_name: storyboard.name,
          journey_id: response.id,
          journey_name: response.name,
        };
        yield put(createMixpanelEvent(JOURNEY_CREATED, mixpanelPayload));
        yield put(createJourneySucceeded(response));
    }
  } catch (error) {
    yield put(createJourneyFailed(error));
  }
}


export const updateJourneyData = createAction(UPDATE_JOURNEY_DATA_REQUEST, (id, request) => {

  return {
    id: id,
    request: request
  };
})


/**
 * Update journey
*/
export const updateJourney = createAction(UPDATE_JOURNEY_REQUEST, (id, request, callback) => {

  return {
    id: id,
    request: request,
    callback
  };
})

export const updateJourneySucceeded = createAction(UPDATING_JOURNEY_SUCCEDDED, (id, response) => {
  return {id, response};
})

export const updateJourneyFailed = createAction(UPDATING_JOURNEY_FAILED, (id, error) => {
  return {id, error};
})

function* updateJourneySaga(action) {
  const { id, request, callback } = action.payload;

  let url = buildUrl(JOURNEY_URL, {
    path: `${id}`
  });

  const updateJourneyAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {

    const response = yield call(updateJourneyAPI);

    if (response) {
      yield put(updateJourneySucceeded(id, response));
      callback()
    }
  } catch (error) {
    yield put(updateJourneyFailed(id, error));
  }
}


/**
 * Update journey
// */
export const deleteJourney = createAction(DELETE_JOURNEY_REQUEST, (id) => {
  return {
    id: id,
  };
})

export const deleteJourneySucceeded = createAction(DELETING_JOURNEY_SUCCEDDED, (id, response) => {
  return {
    id: id,
    response:response
  };
})

export const deleteJourneyFailed = createAction(DELETING_JOURNEY_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* deleteJourneySaga(action) {
  const { id } = action.payload;


  let url = buildUrl(JOURNEY_URL, {
    path: `${id}`
  });

  const deleteJourneyAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteJourneyAPI);
    yield put(deleteJourneySucceeded(id, response));

  } catch (error) {
    yield put(deleteJourneyFailed(id, error));
  }
}


/**
 * Fetch journey id
*/
export const fetchJourney = createAction(FETCH_JOURNEY_REQUEST, (id) => {
  return {
    id: id,
  };
})

const fetchJourneySucceeded = createAction(FETCHING_JOURNEY_SUCCEDDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const fetchJourneyFailed = createAction(FETCHING_JOURNEY_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchJourneySaga(action) {
  const { id } = action.payload;

  const url = buildUrl(JOURNEY_URL, {
    path: `/${id}`
  });

  const fetchJourneyAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchJourneyAPI);
    if (response) {
      yield put(fetchJourneySucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchJourneyFailed(id, error));
  }
}



/**
 * Fetch Journey's
 * 
*/
export const fetchJourneys = createAction(FETCH_JOURNEYS_REQUEST, (request) => {
  return {
    request: request,
  };
})

const fetchJourneysSucceeded = createAction(FETCHING_JOURNEYS_SUCCEDDED, (response) => {
  return response;
})

const fetchJourneysFailed = createAction(FETCHING_JOURNEYS_FAILED, (error) => {
  return error
})

function* fetchJourneysSaga(action) {
  const { request } = action.payload;

  const params = {
    page: request.page,
    limit: request.limit
  };

  const url = buildUrl(JOURNEY_URL, {
    path: `/journeys`,
    queryParams: params
  });

  const fetchJourneysAPI = () => {
    return axios.post(url, {storyboard: request.storyboard}).then(response => response.data);
  }

  try {
    const response = yield call(fetchJourneysAPI);
    if (response) {

      yield put(fetchJourneysSucceeded(response));
    }
  } catch (error) {
    yield put(fetchJourneysFailed(error));
  }
}

export const createJourneyStep = createAction(CREATE_JOURNEY_STEP, (journeyId, selectedNode, request)=> {
  return {
    journeyId: journeyId,
    selectedNode: selectedNode,
    request: request
  };
})

export const creatingJourneyStepSucceded = createAction(CREATE_JOURNEY_STEP_SUCCEDDED, (journeyId, response, selectedNode)=> {
  return {
    journeyId: journeyId,
    response: response,
    selectedNode: selectedNode,
  };
})

export const creatingJourneyStepFailed = createAction(CREATE_JOURNEY_STEP_FAILED, (journeyId, error)=> {
  return {
    journeyId: journeyId,
    error: error
  };
})


function* createJourneyStepSaga(action) {
  const {journeyId, selectedNode, request } = action.payload;

  const url = buildUrl(JOURNEY_URL, {
    path: `${journeyId}/step`
  });

  const createJourneyStepAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createJourneyStepAPI);
    if (response) {
      yield put(creatingJourneyStepSucceded(journeyId, response, selectedNode));
    }
  } catch (error) {
    yield put(creatingJourneyStepFailed(journeyId, error));
  }
}


export const updateJourneyStep = createAction(UPDATE_JOURNEY_STEP, (journeyId, selectedNode, request)=> {
  return {
    journeyId: journeyId,
    selectedNode: selectedNode,
    request: request
  };
})

export const updatingJourneyStepSucceded = createAction(UPDATING_JOURNEY_STEP_SUCCEDDED, (journeyId, selectedNode, response)=> {
  return {
    journeyId: journeyId,
    selectedNode: selectedNode,
    response: response
  };
})

export const updatingJourneyStepFailed = createAction(UPDATING_JOURNEY_STEP_FAILED, (journeyId, error)=> {
  return {
    journeyId: journeyId,
    error: error
  };
})


function* updateJourneyStepSaga(action) {
  const {journeyId, selectedNode, request } = action.payload;

  const url = buildUrl(JOURNEY_URL, {
    path: `${journeyId}/step/${selectedNode}`
  });

  const updateJourneyStepAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateJourneyStepAPI);
    if (response) {
      yield put(updatingJourneyStepSucceded(journeyId, selectedNode, response));
    }
  } catch (error) {
    yield put(updatingJourneyStepFailed(error));
  }
}


export const deleteJourneyStep = createAction(DELETE_JOURNEY_STEP, (journeyId, deleteRequest)=> {

  return {
    journeyId: journeyId,
    deleteRequest: deleteRequest
  };
})

// export const deletingJourneyStepSucceded = createAction(DELETING_JOURNEY_STEP_SUCCEDDED, (journeyId, selectedNode, response)=> {
//   return {
//     journeyId: journeyId,
//     selectedNode: selectedNode,
//     response: response
//   };
// })

// export const deletingJourneyStepFailed = createAction(DELETING_JOURNEY_STEP_FAILED, (journeyId, selectedNode, error)=> {
//   return {
//     journeyId: journeyId,
//     selectedNode: selectedNode,
//     error: error
//   };
// })


// function* deleteJourneyStepSaga(action) {
//   const {journeyId, selectedNode } = action.payload;

//   const url = buildUrl(JOURNEY_URL, {
//     path: `${journeyId}/step/${selectedNode}`
//   });

//   const deleteJourneyStepAPI = () => {
//     return axios.delete(url).then(response => response.data);
//   }

//   try {
//     const response = yield call(deleteJourneyStepAPI);
//     if (response) {
//       yield put(deletingJourneyStepSucceded(journeyId, selectedNode, response));
//     }
//   } catch (error) {
//     yield put(deletingJourneyStepFailed(journeyId, selectedNode, error));
//   }
// }


/**
 * ------------------------------------------------------------
 * Fetch Fitlter asset mappings for layout
 * ------------------------------------------------------------
*/
export const fetchFilterMappingsForJourney = createAction(FETCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST, (journey, request, page, limit) => {
  return {
    journey: journey,
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingFilterMappingsForJourneySucceeded = createAction(FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_SUCCEEDED,
  (journey, response) => {
    return {
      journey: journey,
      response: response
    }
  }
);

const fetchingFilterMappingsForJourneyFailed = createAction(FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_FAILED,
  (journey, error) => {
    return {
      journey: journey,
      error: error
    }
  }
);

function* fetchFilterMappingsForJourneySaga(action) {
  const { journey, request, page, limit } = action.payload;

  const params = {
    page: page,
    limit: limit
  };

  let url = buildUrl(CONTENT_MAPPING_URL, {
    path: 'search',
    queryParams: params
  });

  const fetchFilterMappingsForJourneyAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchFilterMappingsForJourneyAPI);
    if (response) {
      yield put(fetchingFilterMappingsForJourneySucceeded(journey, response));
    }
  } catch (error) {
    yield put(fetchingFilterMappingsForJourneyFailed(journey, error));
  }
}

export const updateJourneyDynamicContentManager = createAction(UPDATE_JOURNEY_DYNAMIC_CONTENT_MANAGER, (journeyId, request) => {
  return {
    journeyId: journeyId,
    request: request
  }
})


export const invalidateJourneyContentManagerMappings = createAction(INVALIDATE_JOURNEY_CONTENT_MANAGER_MAPPINGS);


export default function* journeySaga() {
  yield takeEvery(CREATE_JOURNEY_REQUEST, createJourneySaga);
  yield takeEvery(DELETE_JOURNEY_REQUEST, deleteJourneySaga);
  yield takeEvery(FETCH_JOURNEY_REQUEST, fetchJourneySaga);
  yield takeEvery(FETCH_JOURNEYS_REQUEST, fetchJourneysSaga);
  yield takeEvery(UPDATE_JOURNEY_REQUEST, updateJourneySaga);
  yield takeEvery(CREATE_JOURNEY_STEP, createJourneyStepSaga);
  yield takeEvery(UPDATE_JOURNEY_STEP, updateJourneyStepSaga);
  yield takeEvery(FETCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST, fetchFilterMappingsForJourneySaga);
}